import {
    getLocationSiteComments,
    setLocationSiteError,
    insertLocationSiteComments,
    resetLocationSiteComments
} from "../../../../constants/model-reducers/external/inventory/locationsite/location-site-comment.settings";
import { httpGet, httpPost, httpPostFile } from "../../../../utils/api.utils";

const defaultState = () => ({
    locationSiteComments: [],
    pageIndex: 1,
    hasMoreComments: false,
    isLocationSiteLoaded: false,
    isLocationSiteError: false
});

const initialState = defaultState();

export const locationSiteCommentActions = {
    postLocationSiteComments: (locationId, filename, fileData, comment) => async (dispatch, state) => {

        const timezoneOffset = new Date().getTimezoneOffset() * -1;
        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserID", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("LocationID", locationId);

        var res = await httpPostFile(`external/inventoryManager/setLocationSiteComments?timeZoneOffset=${timezoneOffset}`, formData);

        if (res != null) {
            dispatch({
                type: insertLocationSiteComments,
                locationSiteComments: res?.locationSiteCommentsList[0],
                isLocationSiteLoaded: true,
                isLocationSiteError: false,
                hasMoreData: res?.hasMore
            });
        } else {
            dispatch({
                type: setLocationSiteError,
                isLocationSiteError: true,
                isLocationSiteLoaded: false
            });
        }
    },

    getLocationSiteComments: (locationId, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const existingComments = state().locationComments.locationSiteComments;
        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;


        var res = await httpGet(
            `external/inventoryManager/getLocationSiteComments/${pageIndex}/${pageSize}?locationId=${locationId}` +
            (lastCommentId != null ? `&lastCommentId=${lastCommentId}` : "")
        );

        if (res != null) {
            dispatch({
                type: getLocationSiteComments,
                locationSiteComments: res.locationSiteComments,
                isLocationSiteLoaded: true,
                isLocationSiteError: false,
                pageIndex: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setLocationSiteError,
                isLocationSiteError: true,
                isLocationSiteLoaded: false
            });
        }
    },

    clearLocationSiteComments: () => (dispatch, state) => {
        dispatch({
            type: resetLocationSiteComments,
            locationSiteComments: [],
        })
    },

    deleteLocationSiteComments: (commentId) => async (dispatch, state) => {
        const userId = sessionStorage.getItem("UserID");
        const res = await httpPost(`external/inventoryManager/locationSiteDeleteComment/${commentId}/${userId}`);

        if (res == null) {
            dispatch({
                type: setLocationSiteError,
                isLocationSiteError: true,
                isLocationSiteLoaded: false
            });
        }
    }

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getLocationSiteComments: {
            return {
                ...state,
                locationSiteComments: [
                    ...state.locationSiteComments,
                    ...action.locationSiteComments],
                hasMoreComments: action.hasMoreData,
                pageIndex: action.pageIndex
            };
        }
        case resetLocationSiteComments: {
            return {
                ...state,
                locationSiteComments: action.locationSiteComments,
                hasMoreComments: false,
                pageIndex: 1
            }
        }
        case setLocationSiteError: {
            return {
                ...state,
                isLocationSiteError: action.isLocationSiteError,
                isLocationSiteLoaded: action.isLocationSiteLoaded
            }
        }
        case insertLocationSiteComments: {
            const locComments = Array.isArray(action.locationSiteComments)
                ? action.locationSiteComments : [action.locationSiteComments]
            const existingComments = Array.isArray(state.locationSiteComments)
                ? state.locationSiteComments : [state.locationSiteComments]
            const combinedComments = [
                ...locComments,
                ...existingComments
            ];

            const currentVisibleCount = state.locationSiteComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !== 1;
            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments
            }

            return {
                ...state,
                locationSiteComments: combinedComments.length === 1 ? locComments : updatedComments,
                hasMoreComments: hasMore,
            }
        }
        default:
            return state;
    }
}